<div class="flex flex-col sm:flex-row items-center justify-between gap-4">
  <!-- Items info -->
  <div class="text-sm text-base-content/70">
    @if (totalItems > 0) {
      Showing <strong>{{ startItem }}</strong> - <strong>{{ endItem }}</strong> of <strong>{{ totalItems }}</strong>
    } @else {
      No items
    }
  </div>

  <div class="flex flex-col sm:flex-row items-center gap-4">
    <!-- Page size selector -->
    @if (showPageSizeSelector && pageSizeOptions.length > 0) {
      <div class="flex items-center gap-2 text-sm">
        <span class="text-base-content/70">Rows per page:</span>
        <select
          class="select select-bordered select-sm w-20"
          [value]="pageSize"
          (change)="onPageSizeChange($event)"
          aria-label="Select page size">
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </div>
    }

    <!-- Pagination buttons -->
    @if (totalPages > 1) {
      <!-- Mobile: compact (no boundary buttons, fewer page numbers) -->
      <div class="flex flex-wrap items-center gap-1 sm:hidden" role="group" aria-label="Pagination">
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-disabled]="currentPage === 1"
          [disabled]="currentPage === 1"
          (click)="previousPage()"
          aria-label="Previous page">
          <fa-icon [icon]="faAngleLeft" aria-hidden="true"></fa-icon>
        </button>

        @if (showLeftEllipsisMobile) {
          <span class="btn btn-sm btn-disabled" aria-hidden="true">…</span>
        }

        @for (page of visiblePagesMobile; track page) {
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-primary]="page === currentPage"
            [class.btn-active]="page === currentPage"
            [disabled]="page === currentPage"
            [attr.aria-current]="page === currentPage ? 'page' : null"
            (click)="page === currentPage ? null : goToPage(page)"
            [attr.aria-label]="'Page ' + page">
            {{ page }}
          </button>
        }

        @if (showRightEllipsisMobile) {
          <span class="btn btn-sm btn-disabled" aria-hidden="true">…</span>
        }

        <button
          type="button"
          class="btn btn-sm"
          [class.btn-disabled]="currentPage === totalPages"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()"
          aria-label="Next page">
          <fa-icon [icon]="faAngleRight" aria-hidden="true"></fa-icon>
        </button>
      </div>

      <!-- sm+: full pagination -->
      <div class="hidden sm:flex flex-wrap items-center gap-1" role="group" aria-label="Pagination">
        <!-- First page button -->
        @if (showBoundaryButtons) {
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-disabled]="currentPage === 1"
            [disabled]="currentPage === 1"
            (click)="firstPage()"
            aria-label="First page">
            <fa-icon [icon]="faAnglesLeft" aria-hidden="true"></fa-icon>
          </button>
        }

        <!-- Previous button -->
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-disabled]="currentPage === 1"
          [disabled]="currentPage === 1"
          (click)="previousPage()"
          aria-label="Previous page">
          <fa-icon [icon]="faAngleLeft" aria-hidden="true"></fa-icon>
        </button>

        <!-- Left ellipsis -->
        @if (showLeftEllipsis) {
          <span class="btn btn-sm btn-disabled" aria-hidden="true">…</span>
        }

        <!-- Page number buttons -->
        @for (page of visiblePages; track page) {
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-primary]="page === currentPage"
            [class.btn-active]="page === currentPage"
            [disabled]="page === currentPage"
            [attr.aria-current]="page === currentPage ? 'page' : null"
            (click)="page === currentPage ? null : goToPage(page)"
            [attr.aria-label]="'Page ' + page">
            {{ page }}
          </button>
        }

        <!-- Right ellipsis -->
        @if (showRightEllipsis) {
          <span class="btn btn-sm btn-disabled" aria-hidden="true">…</span>
        }

        <!-- Next button -->
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-disabled]="currentPage === totalPages"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()"
          aria-label="Next page">
          <fa-icon [icon]="faAngleRight" aria-hidden="true"></fa-icon>
        </button>

        <!-- Last page button -->
        @if (showBoundaryButtons) {
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-disabled]="currentPage === totalPages"
            [disabled]="currentPage === totalPages"
            (click)="lastPage()"
            aria-label="Last page">
            <fa-icon [icon]="faAnglesRight" aria-hidden="true"></fa-icon>
          </button>
        }
      </div>
    }
  </div>
</div>

